import LineInterface from 'app/interfaces/LineInterface';
import {makeAutoObservable, set} from 'mobx';

export default class Line {
    allNestedLines = {};

    constructor(line: LineInterface, parentLine?: LineInterface) {
        if (parentLine) {
            this.asLine().parent = parentLine;
        }
        this.asLine().nested_bets = {};
        Object.assign(this, line);
        makeAutoObservable(this);
    }

    update = (newLine: LineInterface): void => {
        Object.keys(newLine).forEach(key => {
            set(this, key, newLine[key]);
        });
    };

    asLine = (): LineInterface => this as unknown as LineInterface;
}
